
import React from 'react';
import AnimateInView from '@/components/ui/animate-in-view';

interface SolutionHeroProps {
  title: string;
  subtitle: string;
  backgroundImage?: string;
}

const SolutionHero: React.FC<SolutionHeroProps> = ({ 
  title, 
  subtitle,
  backgroundImage
}) => {
  return (
    <section aria-labelledby="solution-heading" className="relative py-20 px-4 min-h-[40vh] flex items-center">
      {backgroundImage && (
        <>
          <div className="absolute inset-0 z-0">
            <img 
              src={backgroundImage} 
              alt="Solution background" 
              className="object-cover w-full h-full opacity-15"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-gold/30 to-white z-0"></div>
        </>
      )}
      
      <div className="container mx-auto max-w-4xl text-center relative z-10">
        <AnimateInView animation="fade-in">
          <h1 id="solution-heading" className="text-forti-fi-charcoal mb-6">
            {title}
          </h1>
          <p className="text-forti-fi-charcoal/80 text-xl md:text-2xl mb-8">
            {subtitle}
          </p>
        </AnimateInView>
      </div>
    </section>
  );
};

export default SolutionHero;
